export default __webpack_public_path__ + "df9b5ee20a0bbfd710337270889ed50b.svg";